import React from 'react'
import { Link } from 'react-router-dom'
import Style from './createConnector.module.css'
import { PATH } from '../../../app/routes'

const WizardShell = ({ steps, current, title, children, footer }) => (
    <div className="main-content mn-dashboard">
        <div className="page-content custompaddingdash">
            <div className={`container-fluid ${Style.page}`}>
                <header>
                    <ol className={`breadcrumb ${Style.breadcrumb}`}>
                        <li className="breadcrumb-item"><Link to={PATH.DASHBOARD}>Dashboard</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">New connector</li>
                    </ol>
                    <h1 className={Style.title}>New connector</h1>
                </header>

                <div className={Style.layout}>
                    <nav className={Style.rail} aria-label="New connector steps">
                        <ol className={Style.railList}>
                            {steps.map((step, index) => {
                                const state = index < current ? 'done' : index === current ? 'current' : 'todo'
                                const content = (
                                    <>
                                        <span className={Style.railMarker}>
                                            {state === 'done' ? <i className="uil-check" aria-hidden="true" /> : index + 1}
                                        </span>
                                        <span className={Style.railText}>
                                            <span className={Style.railLabel}>{step.label}</span>
                                            {step.value ? <span className={Style.railValue} title={step.value}>{step.value}</span> : null}
                                        </span>
                                    </>
                                )
                                return (
                                    <li key={step.label} className={[Style.railItem, Style[`rail_${state}`]].join(' ')} aria-current={state === 'current' ? 'step' : undefined}>
                                        {state === 'done' && step.to ? <Link to={step.to} className={Style.railLink}>{content}</Link> : <span className={Style.railLink}>{content}</span>}
                                    </li>
                                )
                            })}
                        </ol>
                    </nav>

                    <section className={Style.panel} aria-labelledby="wizard-step-title">
                        <h2 id="wizard-step-title" className={Style.panelTitle}>{title}</h2>
                        <div className={Style.panelBody}>{children}</div>
                        {footer ? <footer className={Style.panelFooter}>{footer}</footer> : null}
                    </section>
                </div>
            </div>
        </div>
    </div>
)

export default WizardShell
